import { AuthServices } from '@/features/auth/services';

import type { CreateGuardianPlayerRequest } from './create-guardian-player';
import type { GuardianPlayer } from './get-guardian-players';

/** Body for PATCH /api/v1/guardians/me/players/{playerId} — same shape as create. */
export type UpdateGuardianPlayerRequest = CreateGuardianPlayerRequest;

/** Updates a player owned by the signed-in guardian; returns the updated player. */
export async function updateGuardianPlayer(
  playerId: string,
  data: UpdateGuardianPlayerRequest,
): Promise<GuardianPlayer> {
  return await AuthServices.updateGuardianPlayer(playerId, data);
}
